import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Button, Link, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import styles from './Invalid.module.css';
import { NavSections } from '../navigation/NavSections';
/**
 * Message being sent to the devices
 * @param props optional message and endpoint for this screen
 * @returns
 */
export const Invalid = (props) => {
    const { title = 'No Permission Access', message = 'You do not have permission for this page' } = props;
    const goTo = props.goTo;
    const navigate = useNavigate();
    const goToUrl = async (url) => {
        if (url) {
            navigate(url);
        }
        else {
            navigate(-1);
        }
    };
    return (_jsx("div", { className: styles.fullPageContainer, children: _jsxs("div", { className: styles.componentPadding, children: [_jsx(Typography, { variant: "h5", component: "h2", color: "primary", children: title }), _jsx(Typography, { variant: "subtitle1", component: "h6", color: "primary", children: _jsx("i", { children: message }) }), _jsxs(_Fragment, { children: [_jsx("br", {}), _jsxs(Button, { variant: "contained", "data-testid": "url-redirect", onClick: () => goToUrl(goTo?.destinationUrl), children: ["Go ", goTo ? 'to ' + goTo.destination : 'back'] })] })] }) }));
};
/** Only used in v020 */
export const NoProperty = () => {
    return (_jsx("div", { className: styles.fullPageContainer, children: _jsxs("div", { className: styles.componentPadding, children: [_jsx(Typography, { variant: "h5", component: "h2", color: "primary", children: "No Property Selected" }), _jsx(Typography, { variant: "subtitle1", component: "h6", color: "primary", children: _jsx("i", { children: "Please Select A Property To Manage" }) }), _jsxs("i", { children: ["Or", ' ', _jsx(Link, { href: `/${NavSections.LISTVIEW}/Property`, rel: "noopener", children: "create a new property" })] })] }) }));
};
export const NeedZCustomer = () => {
    return (_jsx("div", { className: styles.fullPageContainer, children: _jsxs("div", { className: styles.componentPadding, children: [_jsx(Typography, { variant: "h5", component: "h2", color: "primary", children: "High Level Customer Selected" }), _jsx(Typography, { variant: "subtitle1", component: "h6", color: "primary", children: _jsx("i", { children: "Please Select A End Customer To View" }) })] }) }));
};
export const ErrorState = (props) => {
    const { title, error } = props;
    return (_jsx("div", { className: styles.fullPageContainer, children: _jsxs("div", { className: styles.componentPadding, children: [_jsx(Typography, { variant: "h5", component: "h2", color: "primary", children: title }), _jsx(Typography, { variant: "subtitle1", component: "h6", color: "primary", children: _jsx("i", { children: error ?? 'Error' }) })] }) }));
};
export const RelativeError = (props) => {
    const { title = 'Error', error = 'Error ' } = props;
    return (_jsxs("div", { className: styles.relative, children: [_jsx(Typography, { variant: "h5", component: "h2", color: "primary", children: title }), _jsx(Typography, { variant: "subtitle1", component: "h6", color: "primary", children: _jsx("i", { children: error }) })] }));
};
